export default __webpack_public_path__ + "static/media/img1.749b38b9.png";